<template>
<b-card
    no-body
>
  <div class="m-2">
    <b-row>
      <b-col
        cols="12"
        md="6"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
        <b-button
            variant="primary"
            :to="{ name: 'pin-tag-add'}"
        >
            Add Property Pin Tag
        </b-button>
        </b-col>

        <!-- Search -->
        <b-col
        cols="12"
        md="6"
        >
        <div class="d-flex align-items-center justify-content-end">
            <b-form-input
            v-model="searchQuery"
            class="d-inline-block mr-1"
            placeholder="Search..."
            />
        </div>
      </b-col>
    </b-row>
  </div>

  <div class="mx-2 mb-2">
    <b-alert v-if="searchQuery" show variant="warning" class="p-1">
      Drag-and-drop reordering is disabled while searching. Clear the search box to reorder tags.
    </b-alert>

    <draggable
      v-model="tagsData"
      handle=".pin-tag-handle"
      :disabled="!!searchQuery"
      tag="div"
      @end="updateOrdering"
    >
      <div
        v-for="tag in tagsData"
        :key="tag.id"
        class="d-flex align-items-center p-1 border rounded mb-1"
        :class="{ 'pin-tag-draggable': !searchQuery }"
      >
        <feather-icon
          icon="MenuIcon"
          size="18"
          class="pin-tag-handle mr-1 text-muted"
        />
        <b-img :src="tag.icon || defaultIcon" width="32" height="32" rounded class="tag-icon-thumb mr-1" />
        <b-badge variant="light-secondary" class="mr-1">
          #{{ tag.id }}
        </b-badge>
        <router-link class="tag-name-link flex-grow-1" :to="{ name: 'pin-tag-edit', params: { id: tag.id } }">
          {{ tag.name[currentLocale] }}
        </router-link>

        <b-form-checkbox
            :checked="tag.is_active == 1"
            class="custom-control-primary mr-1"
            name="is_active"
            switch
            @change="changeActive(tag, $event)"
          />

        <b-dropdown
          variant="link"
          toggle-class="text-decoration-none"
          no-caret
        >
          <template v-slot:button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="text-body align-middle mr-25"
            />
          </template>
          <b-dropdown-item :to="{ name: 'pin-tag-edit', params: { id: tag.id } }">
            <feather-icon
              icon="Edit2Icon"
              class="mr-50"
            />
            <span>Edit</span>
          </b-dropdown-item>
          <b-dropdown-item @click="deleteconfirm(tag.id)">
            <feather-icon
              icon="TrashIcon"
              class="mr-50"
            />
            <span>Delete</span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </draggable>

    <div v-if="!isLoading && !tagsData.length" class="text-center text-muted py-2">
      No matching records found
    </div>
  </div>
</b-card>
</template>
<script>
import {
  BCard, BRow, BCol, BFormInput, BFormCheckbox, BButton, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BTooltip, BImg, BFormSelect, BAlert,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import draggable from 'vuedraggable'
import usePropertyPinTagsList from './usePropertyPinTagsList'
import propertyPinTagsStoreModule from '../propertyPinTagsStoreModule'
import defaultIcon from '../defaultTagIcon'
import Ripple from 'vue-ripple-directive'
export default {
  components: {
     BCard,
        BRow,
        BCol,
        BFormInput,
        BFormCheckbox,
        BButton,
        BMedia,
        BAvatar,
        BLink,
        BBadge,
        BDropdown,
        BDropdownItem,
        BTooltip,
        BImg,
        BAlert,
        BFormSelect,
        draggable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      defaultIcon,
    }
  },
  computed: {
    currentLocale() {
      return  this.$i18n.locale;
    },
  },
  setup() {
    const PIN_TAG_APP_STORE_MODULE_NAME = 'app-property-pin-tags'
    if (!store.hasModule(PIN_TAG_APP_STORE_MODULE_NAME)) store.registerModule(PIN_TAG_APP_STORE_MODULE_NAME, propertyPinTagsStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
        if (store.hasModule(PIN_TAG_APP_STORE_MODULE_NAME)) store.unregisterModule(PIN_TAG_APP_STORE_MODULE_NAME)
    })
    const {
      fetchData,
      tagsData,
      isLoading,
      searchQuery,
      deleteData,
      refetchData,
      updateActive,
      updateOrdering,
        } = usePropertyPinTagsList()

    fetchData()

        return {
      tagsData,
      isLoading,
      searchQuery,
     deleteData,
      refetchData,
      updateActive,
      updateOrdering,
        }
  },
   methods:{
    changeActive(item, is_active){
      this.updateActive(item, is_active)
    },
    deleteconfirm(id){
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this Property Pin Tag.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if(value === true){
            this.deleteData(id)
          }
        })
    }
  },
}
</script>

<style scoped>
.tag-name-link {
  color: inherit;
}
.tag-name-link:hover {
  color: #80AC03;
}
.pin-tag-draggable {
  background-color: #fff;
}
.pin-tag-handle {
  cursor: grab;
}
</style>
